// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n#app[data-v-7ca9946a] {\r\n  width: 100%;\r\n  height: 100%;\n}\n[dir] #app[data-v-7ca9946a] {\r\n  margin: 20px;\n}\r\n", ""]);
// Exports
module.exports = exports;
